import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const ManagementWorkFlow = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default ManagementWorkFlow;
